import React, { useState } from 'react';
import { AccordionHeader } from '../../../../../Global/components/layout/accordion-header';
import { ContentSpacer } from '../../../../../global/components/layout/generic-content-spacer';
import { buttonStyles } from '../../../../../global/constants/theme/styles/components/buttonstyles';
import { getCurrentTimeNY } from '../../../../../global/helpers/date-helpers';
import { InstitutionProps } from '../../../models/arc-epi-props';
import { GhlPlan, GhlPlans, OePlanOffer, OePlanOfferings } from '../institution-model';
import GhlPlanView from './ghl-plan-view';

interface Props {
    settings: InstitutionProps,
    ghlPlans: GhlPlans,
    oePlans: OePlanOfferings
}

function GhlSummary(props: Props) {

    const { settings, ghlPlans, oePlans } = props;
    const [expand, setExpand] = useState({
        medical: false,
        dental: false,
        group_life: false,
        disability: false,
        uei: false,
        oeMedical: false,
        oeDental: false,
    });

    const hasOePlans = oePlans?.medical?.length > 0 || oePlans?.dental?.length > 0;
    const currentYear = getCurrentTimeNY()?.getFullYear();
    const buttonClasses = buttonStyles();

    const getMatchGhlPlan = (oePlan: OePlanOffer, currentGhlPlans: GhlPlan[]) => {
        return currentGhlPlans?.find(ghl => ghl?.plan_code === oePlan?.plan_code);
    };

    return (
        <>
            <ContentSpacer>
                <h3 className='h3-alt'>{settings?.ghlSectionTitle}</h3>
            </ContentSpacer>
            {hasOePlans && <ContentSpacer><h3>{settings?.planWithYearTitle?.replace('{year}', currentYear?.toString())}</h3></ContentSpacer>}
            {
                ghlPlans?.medical?.length > 0 &&
                <>
                    <AccordionHeader>
                        <h4>{settings?.medicalPlanSectionTitle}</h4>
                        <button onClick={() => setExpand({ ...expand, medical: !expand.medical })} type='button' className={buttonClasses.linkButton}>{expand.medical ? settings?.closeAllText : settings?.expandAllText}</button>
                    </AccordionHeader>
                    {
                        ghlPlans?.medical?.map(plan => <GhlPlanView settings={settings} ghlPlan={plan} key={plan?.plan_code} expandAll={expand.medical} />)
                    }
                </>
            }
            {
                ghlPlans?.dental?.length > 0 &&

                <>
                    <AccordionHeader>
                        <h4>{settings?.dentalPlanSectionTitle}</h4>
                        <button onClick={() => setExpand({ ...expand, dental: !expand.dental })} type='button' className={buttonClasses.linkButton}>{expand.dental ? settings?.closeAllText : settings?.expandAllText}</button>
                    </AccordionHeader>
                    {
                        ghlPlans?.dental?.map(plan => <GhlPlanView settings={settings} ghlPlan={plan} key={plan?.plan_code} expandAll={expand.dental} />)
                    }
                </>
            }
            {
                ghlPlans?.group_life?.length > 0 &&

                <>
                    <AccordionHeader>
                        <h4>{settings?.groupLifePlanSectionTitle}</h4>
                        <button onClick={() => setExpand({ ...expand, group_life: !expand.group_life })} type='button' className={buttonClasses.linkButton}>{expand.group_life ? settings?.closeAllText : settings?.expandAllText}</button>
                    </AccordionHeader>
                    {
                        ghlPlans?.group_life?.map(plan => <GhlPlanView settings={settings} ghlPlan={plan} key={plan?.plan_code} expandAll={expand.group_life} />)
                    }
                </>
            }
            {
                (ghlPlans?.ltd?.length > 0 || ghlPlans?.std?.length > 0) &&
                <>
                    <AccordionHeader>
                        <h4>{settings?.disabilityPlanSectionTitle}</h4>
                        <button onClick={() => setExpand({ ...expand, disability: !expand.disability })} type='button' className={buttonClasses.linkButton}>{expand.disability ? settings?.closeAllText : settings?.expandAllText}</button>
                    </AccordionHeader>
                    {
                        ghlPlans?.ltd?.map(plan => <GhlPlanView settings={settings} ghlPlan={plan} key={plan?.plan_code} expandAll={expand.disability} />)
                    }
                    {
                        ghlPlans?.std?.map(plan => <GhlPlanView settings={settings} ghlPlan={plan} key={plan?.plan_code} expandAll={expand.disability} />)
                    }

                </>
            }
            {
                ghlPlans?.uei?.length > 0 &&
                <>
                    <AccordionHeader>
                        <h4>{settings?.ueiPlanSectionTitle}</h4>
                        <button onClick={() => setExpand({ ...expand, uei: !expand.uei })} type='button' className={buttonClasses.linkButton}>{expand.uei ? settings?.closeAllText : settings?.expandAllText}</button>
                    </AccordionHeader>
                    {
                        ghlPlans?.uei?.map(plan => <GhlPlanView settings={settings} ghlPlan={plan} key={plan?.plan_code} expandAll={expand.uei} />)
                    }

                </>
            }
            <ContentSpacer>
                {hasOePlans && <ContentSpacer><h3>{settings?.planWithYearTitle?.replace('{year}', (currentYear + 1)?.toString())}</h3></ContentSpacer>}
                {
                    oePlans?.medical?.length > 0 &&
                    <>
                        <AccordionHeader>
                            <h4>{settings?.medicalPlanSectionTitle}</h4>
                            <button onClick={() => setExpand({ ...expand, oeMedical: !expand.oeMedical })} type='button' className={buttonClasses.linkButton}>{expand.oeMedical ? settings?.closeAllText : settings?.expandAllText}</button>
                        </AccordionHeader>
                        {
                            oePlans?.medical?.filter(item=> !item.optout)?.map(plan => <GhlPlanView settings={settings} ghlPlan={{ ...plan, ...getMatchGhlPlan(plan, ghlPlans?.medical) }} key={plan?.plan_code} expandAll={expand.oeMedical} nextYearOffSet={1} />)
                        }
                    </>
                }
                {
                    oePlans?.dental?.length > 0 &&
                    <>
                        <AccordionHeader>
                            <h4>{settings?.dentalPlanSectionTitle}</h4>
                            <button onClick={() => setExpand({ ...expand, oeDental: !expand.oeDental })} type='button' className={buttonClasses.linkButton}>{expand.oeDental ? settings?.closeAllText : settings?.expandAllText}</button>
                        </AccordionHeader>
                        {
                            oePlans?.dental?.filter(item => !item.optout)?.map(plan => <GhlPlanView settings={settings} ghlPlan={{ ...plan, ...getMatchGhlPlan(plan, ghlPlans?.dental) }} key={plan?.plan_code} expandAll={expand.oeDental} nextYearOffSet={1} />)
                        }
                    </>
                }
            </ContentSpacer>
        </>
    );
}

export default GhlSummary;